// /home/ladmin/ESTATA/apps/0001-estata.com/frontend/src/components/HeroParallax.tsx

import { useNavigate } from "react-router-dom";
import Container from "../hooks/Container.tsx";
import { useBreakpoints } from "../hooks/Breakpoints.tsx";

interface HeroParallaxProps {
  header: string;
  welcome: string;
  title: React.ReactNode;
  description: string;
  buttonText: string;
  buttonLink: string;
  image: string;
  textHeight?: string;
  imageHeight?: string;
  backgroundColor?: string;
}

const HeroParallax: React.FC<HeroParallaxProps> = ({  
  header,
  welcome,
  title,
  description,
  buttonText,
  buttonLink,
  image,
  textHeight = "250px",
  imageHeight = "550px",
  backgroundColor = "bg-white/85",
}) => {
  const navigate = useNavigate();
  const { isDesktop } = useBreakpoints();

  // ✅ Konvertiere title zu string für alt-Attribut
  const titleString = typeof title === 'string' ? title : String(title);

  return (
    <div className="hero-parallax">
      {/* Text Section - Hellgrauer Hintergrund */}
      <section 
        className={`${backgroundColor} flex items-center justify-center py-12`}
        style={{ minHeight: textHeight }}
      >
        <Container>
          <div className="max-w-[1510px] mx-auto">            

            {/* Welcome */}
            <p className="text-gray-700 text-lg md:text-xl lg:text-2xl mb-4">
              {welcome}
            </p>

            {/* Title */}
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-6">
              {title}
            </h1>

            {/* Description */}
            <p className="text-gray-700 text-lg md:text-xl lg:text-2xl leading-relaxed font-serif mb-0">
              {description}
            </p>

            {/* Button - nur anzeigen wenn buttonLink nicht leer ist */}
            {buttonLink && (
              <a
                href={buttonLink}
                onClick={(e) => {
                  e.preventDefault();
                  navigate(buttonLink);
                }}
                className="inline-block border border-gray-900 text-gray-900 bg-transparent px-8 py-3 font-medium hover:bg-gray-900 hover:text-white transition-all duration-300 ease-out focus:outline-none focus:ring-2 focus:ring-gray-900 focus:ring-offset-2 mt-8"
              >
                {buttonText}
              </a>
            )}
          </div>
          
        </Container>
      </section>

      {/* Image Section - Mobile: Original-Seitenverhältnis, Desktop: Parallax mit fester Höhe */}
      {isDesktop ? (
        // Desktop: Fixed Background Parallax
        <section
          className="bg-cover bg-center bg-no-repeat bg-fixed mb-[50px] md:mb-[75px] lg:mb-[100px]"
          style={{
            backgroundImage: `url(${image})`,
            height: imageHeight,
          }}
        >
          <div className="w-full h-full bg-black/20" />
        </section>
      ) : (
        // Mobile: Normales Bild im Original-Seitenverhältnis
        <section className="mb-[50px] md:mb-[75px] lg:mb-[100px] relative">
          <img 
            src={image} 
            alt={titleString}
            className="w-full h-auto object-cover"
          />
          <div className="absolute inset-0 bg-black/20" />
        </section>
      )}
    </div>
  );
};

export default HeroParallax;
